<template>
  <v-dialog
    v-model="dialog"
    width="600"
    >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        outlined
        small
        class="rounded-lg fill-width"
        color="primary"
        v-bind="attrs"
        v-on="on"
        >
        <v-icon small color="primary" class="mr-1" style="margin-top: -2px">mdi-plus-circle</v-icon> Crear subcuenta
      </v-btn>
    </template>

    <v-card>
      <v-card-title
        >
        Nueva subcuenta en {{ subAccount.name }}
      </v-card-title>

      <v-card-text>
        <v-form
          ref="form"
          lazy-validation
          v-model="valid"
          >
          <v-row>
            <v-col
              cols="12"
              class="pb-0"
              >
              <v-text-field
                outlined
                color="primary"
                label="Nombre del concepto"
                v-model="attributes.name"
                :rules="[
                  v => !!v || 'Campo obligatorio'
                ]"
                hint="Por ejemplo: Gas, Agua potable, Energía eléctrica"
                persistent-hint
                ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions
        style="gap: 8px"
        >
        <v-spacer></v-spacer>
        <v-btn
          text
          color="grey"
          @click="dialog = false"
          >
          Cancelar
        </v-btn>

        <v-btn
          color="primary"
          @click="perform"
          class="rounded-lg"
          >
          Crear
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { CreateConcept } from '@/graphql/mutations/accounts'

export default {
  data: () => ({
    dialog: false,
    valid: true,
    attributes: {
      subAccountId: null,
      name: null
    }
  }),

  props: {
    subAccount: {
      type: Object,
      required: true
    }
  },

  created () {
    this.attributes.subAccountId = this.subAccount.id
  },

  methods: {
    perform () {
      if (this.$refs.form.validate()) {
        this.$apollo.mutate({
          mutation: CreateConcept,
          variables: {
            input: {
              attributes: this.attributes
            }
          }
        }).then( res => {
          this.dialog = false
          this.$emit('reload')
        })
      }
    }
  }
}
</script>
